import * as invoiceActionTypes from "./actions/invoice/actionTypes"

const initInvoiceDetails: NewInvoiceDetails = {
  invoiceNum: '',
  rrn: '',
  itemName: ['Product 1'],
  quantity: ['2'],
  unitPrice: [100],
  amount: [200],
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  countryCode: 'PH'
}
const invoiceForm = (state: NewInvoiceDetails = initInvoiceDetails, action: any): NewInvoiceDetails => {
  switch (action.type) {
    case invoiceActionTypes.UPDATE_INVOICE_FORM_SUCCESSFUL:
      const { payload } = action
      return { ...payload, amount: payload.quantity.map((quantity: number, index: number) => { return +quantity * +payload.unitPrice[index] }) }
    case invoiceActionTypes.CLEAR_INVOICE_FORM_SUCCESSFUL:
      return initInvoiceDetails
    default:
      return state
  }
}

const invoiceUrl = (state: string = '', action: GenerateInvoiceAction): string => {
  switch (action.type) {
    case invoiceActionTypes.GENERATE_INVOICE_SUCCESSFUL:
      const { payload } = action
      if (payload.invoiceUrl) {
        return payload.invoiceUrl
      } else {
        return ''
      }
    case invoiceActionTypes.CLEAR_INVOICE_FORM_SUCCESSFUL:
      return ''
    default:
      return state
  }
}

const apiError = (state: any = {}, action: GenerateInvoiceAction): any => {
  switch (action.type) {
    case invoiceActionTypes.GENERATE_INVOICE_SUCCESSFUL:
      const { payload } = action
      if (payload.code) {
        return payload
      } else {
        return state
      }
    case invoiceActionTypes.GENERATE_INVOICE_FAILED:
    default:
      return state
  }
}

const defaultUser: User = {
  firstName: 'Jane',
  lastName: 'Doe',
  email: 'janedoe@test.com',
  mayaCustomerId: undefined
}
const currentUser = (state: User = defaultUser, action: any): User => {
  return state
}

export { invoiceForm, currentUser, invoiceUrl, apiError }